import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface LocationOption {
  id: string;
  name: string;
  type: string;
  isDefault: boolean;
}

interface LocationState {
  /** null = All Locations (manager view). Set = scoped to one location. */
  selectedLocationId: string | null;
  selectedLocationName: string | null;
  setLocation: (id: string | null, name: string | null) => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      selectedLocationId: null,
      selectedLocationName: null,
      setLocation: (id, name) => set({ selectedLocationId: id, selectedLocationName: name }),
    }),
    { name: 'clearring-location-ctx' },
  ),
);
